import { createContext } from 'react';

const reqsSectorsContext = createContext();

export default reqsSectorsContext;